/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';

import { Month } from '../offices';
import {
  AccountingWipApplyRequestDto,
  AccountingWipApplyResponseDto, AccountingWipCreateAndPrintRequestDto,
  AccountingWipInitDto,
  AccountingWipJobDto,
  AccountingWipJournalLogItemDto,
  AccountingWipMonthDto,
  AccountingWipPrintRequestDto,
  AccountingWipRecalculateRequestDto,
  AccountingWipRecalculateResponseDto,
  AccountingWipReportRequestDto,
  WipEntryPoint,
} from './accounting-wip.dto';

export const AccountingWipInitMapper = entity<AccountingWipInitDto>({
  months: arrayOf(subentity<AccountingWipMonthDto>({
    month: enumeration(Month),
  })),
});
export const AccountingWipJobMapper = entity<AccountingWipJobDto>({});
export const AccountingWipApplyRequestMapper = entity<AccountingWipApplyRequestDto>({
  month: enumeration(Month),
});
export const AccountingWipApplyResponseMapper = entity<AccountingWipApplyResponseDto>({
  entryPoint: enumeration(WipEntryPoint),
  journal: arrayOf(AccountingWipJobMapper),
});
export const AccountingWipRecalculateRequestMapper = entity<AccountingWipRecalculateRequestDto>({
  month: enumeration(Month),
});
export const AccountingWipRecalculateResponseMapper = entity<AccountingWipRecalculateResponseDto>({});
export const AccountingWipJournalLogItemMapper = entity<AccountingWipJournalLogItemDto>({});
export const AccountingWipPrintRequestMapper = entity<AccountingWipPrintRequestDto>({});
export const AccountingWipCreateAndPrintRequestMapper = entity<AccountingWipCreateAndPrintRequestDto>({});
export const AccountingWipReportRequestMapper = entity<AccountingWipReportRequestDto>({
  month: enumeration(Month),
});
